// src/pages/Scholarships.js
// ──────────────────────────────────────────────────────────────────────────
// Funding & scholarships — MTI supports CDF, donor and sponsorship learners.
// ──────────────────────────────────────────────────────────────────────────

import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import theme from '../theme/theme';

const Header = styled.header`
  background: ${theme.color.blueDeep}; color: #fff;
  padding: 7rem ${theme.layout.gutter} 5rem;
  .inner { max-width: ${theme.layout.maxWidth}; margin: 0 auto; }
  h1 { font-weight: 400; font-size: clamp(2.4rem, 6vw, 4rem); color: #fff; margin-top: 1.2rem; }
  p { margin-top: 1rem; max-width: 54ch; font-weight: 300; color: rgba(255,255,255,0.82); }
  .kicker { color: #fff; }
`;
const Section = styled.section` max-width: ${theme.layout.maxWidth}; margin: 0 auto; padding: 5rem ${theme.layout.gutter}; `;
const Grid = styled.div`
  display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem; margin-top: 2.5rem;
  @media (max-width: 720px) { grid-template-columns: 1fr; }
  .c { border: 1px solid ${theme.color.line}; border-top: 4px solid ${theme.color.lemon}; border-radius: ${theme.layout.radius}; padding: 1.8rem; background: #fff; }
  .c h3 { font-weight: 500; font-size: 1.35rem; color: ${theme.color.accent}; }
  .c p { margin: 0.6rem 0 0; font-size: 0.95rem; color: ${theme.color.inkSoft}; }
`;
const CTA = styled.div`
  background: ${theme.color.paperAlt}; border: 1px solid ${theme.color.line}; border-radius: ${theme.layout.radius};
  padding: 2.5rem; margin-top: 3rem; text-align: center;
  h2 { font-weight: 400; font-size: clamp(1.6rem, 4vw, 2.2rem); }
  p { color: ${theme.color.inkSoft}; margin: 0.7rem 0 1.4rem; }
  a { display: inline-block; background: ${theme.color.accent}; color: #fff; font-weight: 700; padding: 13px 28px; border-radius: ${theme.layout.radius}; &:hover { background: ${theme.color.accentDark}; } }
`;

const OPTIONS = [
  { h: 'CDF sponsorship', p: 'We support learners funded through the Constituency Development Fund (CDF). If your ward or constituency has sponsored you for skills training, we can enrol you and handle the required documentation.' },
  { h: 'Donor & NGO sponsorship', p: 'We work with donors and NGOs that sponsor youths, women and vulnerable groups into skills training as part of poverty-reduction and empowerment programmes.' },
  { h: 'Employer & organisation sponsorship', p: 'Companies and organisations can sponsor staff or community members for specific courses, including tailor-made entrepreneurship training.' },
  { h: 'Self-sponsorship', p: 'Pay your own fees in manageable terms. Speak to us about the fee structure and what each course includes.' },
];

function Scholarships() {
  return (
    <>
      <Navbar />
      <Header>
        <div className="inner">
          <span className="kicker">Funding your training</span>
          <h1>Scholarships &amp; sponsorship</h1>
          <p>Cost shouldn’t stand between you and a skill. We support several funding routes so more people can train at MTI.</p>
        </div>
      </Header>

      <Section>
        <span className="kicker">Ways to fund your place</span>
        <h2 style={{ fontWeight: 400, fontSize: 'clamp(1.8rem,4vw,2.6rem)', marginTop: '1rem' }}>How learners pay</h2>
        <Grid>
          {OPTIONS.map((o) => <div className="c" key={o.h}><h3>{o.h}</h3><p>{o.p}</p></div>)}
        </Grid>

        <CTA>
          <h2>Not sure which applies to you?</h2>
          <p>Tell us your situation and we’ll help you find a funding route — CDF, donor, sponsor or self.</p>
          <Link to="/apply">Start your application →</Link>
        </CTA>
      </Section>

      <Footer />
    </>
  );
}

export default Scholarships;
